export const LMS_NONE_OPTION_LABEL =
  "My district does not have a LMS/I do not want to integrate with a LMS";

export enum LMSOption {
  GoogleClassroom = "Google Classroom",
  Canvas = "Canvas",
  Schoology = "Schoology",
  D2LBrightspace = "D2L/Brightspace",
  itslearning = "itslearning",
  None = "None",
  Other = "Other/Custom",
}
